// extracted by mini-css-extract-plugin
module.exports = {"SearchModal":"SearchModal_SearchModal__HDlSK","SearchModal_header":"SearchModal_SearchModal_header__k3HPq","SearchModal_text":"SearchModal_SearchModal_text__qjtC1"};